import React, { createContext, useContext, useReducer } from 'react';

export const ContentPageContext = createContext();

export const ContentPageProvider = ({ reducer, initialState, children }) => (
  <ContentPageContext.Provider value={useReducer(reducer, initialState)}>{children}</ContentPageContext.Provider>
);

export const useContentPageState = () => useContext(ContentPageContext);
